export const CAREERS_EMAIL = "mailto:info@ateno.co?subject=Careers%20at%20Ateno";

// TODO(founder): Confirm any additional benefits before publishing them.
export const CAREERS_PERKS = ["Equity", "Flexible hybrid"];

// Add approved openings here when formal roles are ready to publish.
export const CAREER_OPPORTUNITIES = [];
